import { render, staticRenderFns } from "./DaktelaChatIntegrationForm.vue?vue&type=template&id=a0068d8a&"
import script from "./DaktelaChatIntegrationForm.vue?vue&type=script&lang=js&"
export * from "./DaktelaChatIntegrationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports